module.exports = "<label class=\"label\">{{ ::$ctrl.$translate(field.label) }}</label>\n";